<template>
  <v-container fluid>
    <v-layout>
      <v-flex
        justify-center
      >
        <material-card
          :height="heightCard"
          elevation-3
          style="background-color: #E1E1E1; overflow:auto">
          <v-layout
            xs12
            sm12
            md12
            justify-center
            align-center
            fill-height
            column
            class="mb-3"
          >
            <span style="color: #273771;font-weight: 400; font-size: 25pt">
              {{ (idioma === 0)?'Página Não Encontrada': 'Page Not Found' }}
            </span>

            <a href="/">
              <img
                :style="{'height': '200px'}"
                src="assets/videos/brcorte_caw.gif">
            </a>

            <v-card class="pa-2 mx-lg-auto">
              <i>{{ (idioma === 0)?'"Não Estou Achando Nada!!!"': '"I\'m not finding!!!"' }}</i>
            </v-card>

            <v-btn
              color= "primary"
              href="/">
              {{ (idioma === 0) ? 'Ir para Página Inicial' : 'Go to Home' }}
            </v-btn>

          </v-layout>
        </material-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['strings', 'idioma']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 100) + 'px'
    },
    heightVideo () {
      return String(this.$vuetify.breakpoint.height - 300) + 'px'
    }
  }
}
</script>
